import { shortFormsEnabled } from '../../../brand/tenant';
import { PAYMENT_TYPES_CREDIT_INVOICE, PAYMENT_TYPES_OPTIONS } from '../../../constants';

// У серых дилеров доп. оборудования и услуг нет: сделка идёт с основной информации
// сразу к анкете или оплате.
export const EXTRA_STEP_TITLES = ['Доп.оборудование', 'Доп.услуги'];

export const withoutExtraSteps = (steps, short = shortFormsEnabled()) =>
  short ? steps.filter((step) => !EXTRA_STEP_TITLES.includes(step.title)) : steps;

// Шаги 2 и 3 остаются в нумерации сделки (на них завязан бэк), поэтому экран
// не показываем, а проходим насквозь — как «Сохранить и продолжить» с пустым списком.
export const shouldSkipExtras = ({ short = shortFormsEnabled(), step, ordersCount, loading }) =>
  Boolean(short) && (step === 2 || step === 3) && ordersCount > 0 && !loading;

// Куда ведёт «Назад» с анкеты или оплаты.
export const stepBeforePayment = (short = shortFormsEnabled()) => (short ? 1 : 311);

// Серые дилеры продают в кредит: «Автокредит» выбран сразу, менеджеру остаётся клиент и автомобиль.
export const defaultPaymentOption = (short = shortFormsEnabled()) =>
  short ? PAYMENT_TYPES_OPTIONS.find((option) => option.value === PAYMENT_TYPES_CREDIT_INVOICE) : null;
